export default "__VITE_ASSET__BQTkHJFr__"